export const getInitialState = () => ({
  data: {
    urlToken: '',
    contactSelected: {},
    chosenContactType: '',
    message: ''
  },
});

export const state = getInitialState();
